import { Component } from '@angular/core';


@Component({
  selector: 'ff-mfa-does-not-exist',
  templateUrl: './mfa_does_not_exist.component.html',
  styleUrls: ['./mfa_does_not_exist.component.scss'],
})
export class MfaDoesNotExistComponent {

  constructor(

  ) {}
}
